import { PropsWithChildren } from 'react';
import { MapProvider as ReactMapGLMapProvider } from 'react-map-gl/mapbox';
import MapLayerInteractionsProvider from '../MapLayerInteractionsProvider';

const MapProvider = ({ children }: PropsWithChildren) => (
  <ReactMapGLMapProvider>
    <MapLayerInteractionsProvider>{children}</MapLayerInteractionsProvider>
  </ReactMapGLMapProvider>
);

export default MapProvider;
